<template>
  <div>
    <div class="row justify-between">
      <q-checkbox label="Показать удалённые услуги" v-model="withTrashed"/>
      <div></div>
      <q-table-columns
          color="secondary"
          class="q-mr-sm"
          v-model="visibleColumns"
          :columns="columns"
      />
    </div>
    <h-table
        :data='data'
        row-key="label"
        :columns='columns'
        :visible-columns="visibleColumns"
        :filter="filter"
        :pagination.sync="serverPagination"
        :rows-per-page-options="perPageOptions"
        :loading="loading"
        ref="table"
        @request="fetchData"

    >
      <q-td
          slot="body-cell-bill_number"
          class="cursor-pointer"
          style="text-decoration: underline"
          slot-scope="props"
      >
        {{ props.row.bill_number }}

        <q-tooltip
            v-if="props.row.bill_number"
            :delay="500"
            :offset="[0, 5]"
        >
          <p class="q-mb-xs">Сумма: {{ props.row.amount / 100 }}</p>
          <p class="q-mb-xs">Оплачено: {{ props.row.paid_amount / 100 }}</p>
          <p class="q-mb-xs">Статус: {{ getBillStatus(props.row.status) }}</p>
          <p v-if="props.row.valid_until" class="q-mb-xs">Период: {{
              getBillPeriod(props.row.destination, props.row)
            }}</p>
          <p v-if="props.row.paid_at" class="q-mb-xs">Дата оплаты:
            {{ formatDate(props.row.paid_at, 'DD.MM.YYYY, HH:mm:ss') }}</p>
        </q-tooltip>
      </q-td>
      <q-td
          slot="body-cell-active"
          slot-scope="props"
      >
        <q-toggle
            v-if="!props.row.deleted_at"
            :value="props.row.active"
            @input="val => val ? activateService(props.row) : deactivateService(props.row)"
            color="positive"
        />
      </q-td>
      <q-td
          slot="body-cell-edit"
          slot-scope="props"
          class="text-right"
      >
        <q-btn
            v-if="!props.row.deleted_at"
            @click="editService(props.row)"
            :disable=!canEdit()
            icon="edit"
            color="tertiary"
            class="hover-primary"
            flat
            round
        >
          <q-tooltip
              :delay="500"
              :offset="[0, 5]"
          >
            Редактировать
          </q-tooltip>
        </q-btn>

        <q-btn
            v-if="serviceCanBeProlonged(props.row)"
            @click="prolongService(props.row)"
            icon="repeat_one"
            color="tertiary"
            class="hover-primary"
            flat
            round
        >
          <q-tooltip
              :delay="500"
              :offset="[0, 5]"
          >
            Продлить услугу
          </q-tooltip>
        </q-btn>

        <q-btn
            v-if="!props.row.deleted_at"
            @click="deleteService(props.row)"
            icon="delete"
            color="tertiary"
            class="hover-negative"
            flat
            round
        >
          <q-tooltip
              :delay="500"
              :offset="[0, 5]"
          >
            Удалить
          </q-tooltip>
        </q-btn>
      </q-td>
    </h-table>
    <q-modal
        v-model="editableServiceOpened"
        content-css="width: 400px;"
    >
      <div class="q-pa-lg bill">
        <q-field>
          <q-datetime
              v-model="editableService.validUntil"
              format="YYYY-MM-DD"
              minimal
              clearable
              stack-label="Действительный до"
          />
        </q-field>
        <q-field>
          <q-input
              v-model="editableService.description"
              stack-label="Описание"
          />
        </q-field>
      </div>
      <div class="row justify-end q-pa-lg">
        <q-btn
            @click="updateService"
            label="Сохранить"
            color="primary"
            class="q-mr-sm"
        />
        <q-btn
            @click="editableServiceOpened = false"
            label="Отмена"
            color="primary"
            flat
        />
      </div>
    </q-modal>
  </div>
</template>

<script>
import _ from 'lodash';
import HTable from '@/HTable';
import HTh from '@/HTh';

import tableHelpers from 'components/HTable/helpers';
import columns from './mixins/columns';
import api from 'mixins/api';

import formatDate from "../../mixins/formatDate";

import {
  QField,
  QInput,
  QSelect,
  QBtn,
  QIcon,
  QTable,
  QTableColumns,
  QCheckbox,
  QTooltip,
  QTr,
  QTh,
  QTd,
  QPopover,
  QModal,
  QDatetime,
  QToggle,
  date,
} from 'quasar';

import billService from "../../mixins/billService";

export default {
  name: 'ServicesList',

  components: {
    HTable,
    HTh,
    QField,
    QInput,
    QSelect,
    QBtn,
    QIcon,
    QTable,
    QTableColumns,
    QTooltip,
    QTr,
    QTh,
    QTd,
    QPopover,
    QModal,
    QDatetime,
    QToggle,
    QCheckbox,
  },

  mixins: [
    tableHelpers,
    columns,
    api,
    formatDate,
    billService,
  ],

  props: {
    projectId: String
  },

  data() {
    return {
      visibleColumns: this.getVisibleColumns() || [
        'service_name',
        'bill_number',
        'description',
        'service_reusable',
        'service_type',
        'active',
        'edit',
      ],
      data: [],
      loading: false,
      perPageOptions: [10, 20, 40, 60],
      filterCols: {},
      modalOpened: false,
      editableServiceOpened: false,
      editableService: {
        id: null,
        validUntil: null,
        description: null,
        loading: false
      },
      withTrashed: false,
    };
  },

  mounted() {
    this.updateServicesList();
  },

  watch: {
    withTrashed: function (value) {
      this.fetchData({
        pagination: this.serverPagination,
        filter: this.filter
      })
    }
  },

  methods: {
    fetchData({pagination, filter}) {
      filter = filter.concat(`filter[withTrashed]=${this.withTrashed}`);
      this.query = this.getQuery(pagination, filter);
      this.loading = true;
      this.api.get(`projects/${this.$route.params.id}/services/${this.query}`).then(response => {
        if (this.verifyResponse(response)) {
          this.updatePagination(pagination, response.data.total);
          this.updateData(this.flattenData(response.data.services));
          this.$store.commit('servicesList/setData', response.data);
          this.$store.dispatch('project/fetchProject', this.$route.params.id);
        }
        this.loading = false;
      }).catch(error => {
        console.error(error);
        this.loading = false;
      });
    },

    updateServicesList() {
      this.fetchData({
        pagination: this.serverPagination,
        filter: this.filter
      });
    },

    flattenData(data) {
      let flattenData = [];

      _.forEach(data, (value) => {
        let flattenObj = {};
        value.loading = false;
        _.forEach(value, (value, key) => {
          if (value && value.constructor === Object) {
            let prefix = key;
            _.each(value, (value, key) => {
              flattenObj[`${prefix}_${key}`] = value;
            });
          } else {
            flattenObj[key] = value;
          }
        });
        flattenData.push(flattenObj);
      });

      return flattenData;
    },

    editService(data) {
      this.editableServiceOpened = true;
      this.editableService = Object.assign(this.editableService, {
        id: data.id,
        validUntil: data.valid_until,
        description: data.description
      });
    },

    updateService() {
      this.editableService.loading = true;

      let data = {
        'valid_until': date.formatDate(this.editableService.validUntil, 'YYYY-MM-DD'),
        'description': this.editableService.description
      };

      this.$http.put(`api/v1.0/projects/${this.$route.params.id}/services/${this.editableService.id}`, data)
          .then(response => {
            this.$q.notify({message: 'Сохранено', type: 'positive'});
            this.updateServicesList();

            this.editableServiceOpened = false;
          })
          .catch(error => {
            if (error.response.data.message) {
              this.$q.notify({message: error.response.data.message, type: 'negative'});
            }
            if (error.response.data.errors) {
              _.forIn(error.response.data.errors, (value, key) => {
                this.$q.notify({message: value[0], type: 'negative'});
              });
            }
          })
          .then(() => {
            this.editableService.loading = false;
          });
    },

    activateService(service) {
      if (!service.active) {
        this.$q.dialog({
          title: 'Включить услугу?',
          message: 'Перед включением услуги убедитесь что аналогичные (тарифы) уже отключены',
          ok: 'Да',
          cancel: 'Нет'
        }).then(() => {
          service.loading = true;
          this.$q.notify({message: 'Сохраняю...', type: 'info'});

          this.$http.post(`api/v1.0/projects/${this.$route.params.id}/services/${service.id}/activate`, service).then(response => {
            service.active = true;
            this.$q.notify({message: 'Сохранено', type: 'positive'});
            this.updateServicesList();
          }).catch(error => {
            service.active = false;

            if (error.response.status === 422) {
              this.$q.notify({message: 'В проекте уже есть активная аналогичная услуга/тариф', type: 'negative'});
            } else {
              if (error.response.data.message) {
                this.$q.notify({message: error.response.data.message, type: 'negative'});
              }
              if (error.response.data.errors) {
                _.forIn(error.response.data.errors, (value, key) => {
                  this.$q.notify({message: value[0], type: 'negative'});
                });
              }
            }
          }).then(() => {
            service.loading = false;
          });
        });
      }
    },

    deactivateService(service) {
      if (service.active) {
        this.$q.dialog({
          title: 'Отключить услугу?',
          ok: 'Да',
          cancel: 'Нет'
        }).then(() => {
          service.loading = true;
          this.$q.notify({message: 'Сохраняю...', type: 'info'});

          this.$http.post(`api/v1.0/projects/${this.$route.params.id}/services/${service.id}/deactivate`, service).then(response => {
            service.active = false;
            this.$q.notify({message: 'Сохранено', type: 'positive'});

            this.updateServicesList();
          }).catch(error => {
            if (error.response.data.message) {
              this.$q.notify({message: error.response.data.message, type: 'negative'});
            }
            if (error.response.data.errors) {
              _.forIn(error.response.data.errors, (value, key) => {
                this.$q.notify({message: value[0], type: 'negative'});
              });
            }
          }).then(() => {
            service.loading = false;
          });
        });
      }
    },

    deleteService(service) {
      if (!service.active) {
        this.$q.dialog({
          title: 'Удалить услугу?',
          message: 'Вы уверены что хотите удалить услугу? Убедитесь, что услуга не имеет счетов.',
          ok: 'Да',
          cancel: 'Нет'
        }).then(() => {
          service.loading = true;
          this.$q.notify({message: 'Удаляю...', type: 'info'});

          this.$http.delete(`api/v1.0/projects/${this.$route.params.id}/services/${service.id}`, service).then(response => {
            service.active = false;
            this.$q.notify({message: 'Удалено', type: 'positive'});

            this.updateServicesList();
          }).catch(error => {
            if (error.response.data.message) {
              this.$q.notify({message: error.response.data.message, type: 'negative'});
            }
            if (error.response.data.errors) {
              _.forIn(error.response.data.errors, (value, key) => {
                this.$q.notify({message: value[0], type: 'negative'});
              });
            }
          });
        });
      } else {
        this.$q.notify({message: 'Отключите услугу перед ее удалением', type: 'negative'});
      }
    },

    serviceCanBeProlonged(service) {
      return service.active && !service.service_groupId.includes('basic_cloud_startup_fee');
    },

    prolongService(service) {
      this.$http.get(`api/v1.0/projects/${this.$route.params.id}/services/${service.id}/prolong`)
          .then(response => {
            this.$q.notify({
              message: `Услуга успешно продлена`,
              type: 'positive',
            });

            this.updateServicesList();
          })
          .catch(error => {
            this.$q.notify({
              message: `${error.message}`,
              type: 'negative',
            });
          });
    },

    canEdit () {
        return this.$auth.user().role === 'root'
    },
  },
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ServicesList/ServicesList.vue